/**
 * Időszakos pta_cashier role-grant FE wrapper.
 *
 * BE route-ok:
 *   GET    /groups/:id/cashier-grants
 *   POST   /groups/:id/cashier-grants     body: { userId, validFrom?, validTo? }
 *   PATCH  /cashier-grants/:id            body: { validTo: string | null }
 *   DELETE /cashier-grants/:id            (azonnali revoke)
 *   GET    /users/search?q=&groupId=&limit=
 */

import type {
  CashierGrant,
  CashierGrantInput,
  CashierGrantUpdateInput,
  UserSearchHit,
} from '@pta/types';
import { apiCall } from './client';

export function fetchCashierGrants(groupId: number): Promise<CashierGrant[]> {
  return apiCall(`/groups/${groupId}/cashier-grants`);
}

export function createCashierGrant(
  groupId: number,
  input: CashierGrantInput,
): Promise<CashierGrant> {
  return apiCall(`/groups/${groupId}/cashier-grants`, {
    method: 'POST',
    body: input,
  });
}

export function updateCashierGrant(
  roleId: number,
  input: CashierGrantUpdateInput,
): Promise<CashierGrant> {
  return apiCall(`/cashier-grants/${roleId}`, {
    method: 'PATCH',
    body: input,
  });
}

export function revokeCashierGrant(roleId: number): Promise<CashierGrant> {
  return apiCall(`/cashier-grants/${roleId}`, { method: 'DELETE' });
}

export function searchUsersForGroup(
  groupId: number,
  q: string,
  limit = 20,
): Promise<UserSearchHit[]> {
  return apiCall('/users/search', {
    query: { q, groupId, limit },
  });
}
